/** Lead-wide bonus state and scoped payment/rejection transport. */
import apiClient from './client.js';

export const fetchVideoBonuses = (leadId) =>
  apiClient.get('/video-bonuses', { params: { leadId } }).then(r => ({ bonuses: r.data.bonuses, summary: r.data.summary }));

export const markVideoBonusPaid = (id, paid) =>
  apiClient.patch(`/video-bonuses/${id}/paid`, { paid }).then(r => r.data.bonus);

export const setVideoBonusRejection = (id, rejected, reason) =>
  apiClient.patch(`/video-bonuses/${id}/rejection`, { rejected, reason }).then(r => r.data.bonus);
